const pathsManifest = {
  FrontPage: '/',

  PriceMyRentalPage: '/rental-manager/price-my-rental',
  PriceMyRentalPageResults: '/rental-manager/price-my-rental/results',
  MarketTrendsPage: '/rental-manager/market-trends',
  UnsubscribePage: '/rental-manager/growth/unsubscribe/marketUpdate',
  UnsubscribeAllPage: '/rental-manager/growth/unsubscribe/marketUpdateAll',

  StatsPage: '/rental-manager/growth/stats-page',
  WebSocketPage: '/rental-manager/growth/ws-page',

  ZRMLoginPage: '/rental-manager/login',
};

export default pathsManifest;
